<template>
   <el-dialog
    title="单位制度"
    :visible.sync="rgimeDialogFlg"
    width="45%"
    :modal-append-to-body='false'
    @close="regimeDialogClosed">
    <div v-html="tinymceHtml">
      {{tinymceHtml}}
    </div>
    <div slot="footer">
      <el-button 
        type="primary" 
        @click="rgimeBtn" 
        size="small">
        <span>确定</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    rgimeFlg: Boolean
  },
  data () {
    return {
      rgimeDialogFlg: false,
      tinymceHtml:''
    }
  },
  created() {
    this.getList();
  },
  watch: {
    rgimeFlg(val) {
      this.rgimeDialogFlg = val
    },
    rgimeDialogFlg(val) {
      this.$emit('rgime-dialogFlg', val)
    },

  },
  mounted () {

  },
  methods: {
    getList() {
        var that = this;
        this.$post('/apis/manage/home/getRegime',{
              token:sessionStorage.getItem('token'),
        }).then(function(res){
            if(res.errno == 0){
              that.tinymceHtml = res.data;
            }else if(res.errno == 99){
              
            }else{
              
            }
        }).catch(function(err){
            window.console.log(err);
        });
    },
    regimeDialogClosed() {
      //this.tinymceHtml = ''
    },
    rgimeBtn() {
      this.rgimeDialogFlg = false
    },

  }
}
</script>

<style lang="less" scoped>

</style>